'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/call-bind-apply-helpers@1.0.2/~/call-bind-apply-helpers/functionCall.js
// module id = 148
// module chunks = 0